import moment from 'moment';

class SpotlightFeature {
  /* title the feature it can be either direct string or a translation key */
  title: string;

  /* feature description */
  description: string;

  /* learn more url of feature */
  url: URL;

  /* release date in UTC */
  date: moment.Moment;

  constructor(title: string, description: string, url: URL, date: moment.Moment) {
    this.title = title;
    this.description = description;
    this.date = date;
    this.url = url;
  }

  static fromJson(data: Record<string, string>): SpotlightFeature {
    const date = moment(data.date);

    if (!moment(data.date).isValid()) {
      throw new Error('Invalid date in spotlight feature');
    }

    return new SpotlightFeature(data.title, data.description, new URL(data.url), date);
  }
}

export default SpotlightFeature;
